<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Manage Expenses | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			<button class="btn btn-primary float-right" @click="addModal"><i class="fa fa-plus"></i> Add Expense</button>
		</div>
		<div class="card-body overflow-auto">
			<div class="col-sm-4">
				<div class="form-group">
					<span class="right badge badge-secondary">Select From Date:</span>
      		<input type="date" class="form-control" v-model="from" placeholder="Select from date">
      	</div>
			</div>
      <div class="col-sm-4">
				<div class="form-group">
					<span class="right badge badge-secondary">Select To Date:</span>
      		<input type="date" class="form-control" v-model="to" placeholder="Select to date">
      	</div>
      </div>
      <div class="col-sm-4">
				<div class="form-group">
					<span class="right badge badge-secondary">Choose Type:</span>
      		<v-select v-model="search_type" type="text" label="type" :options="expense_types" :reduce="expense_types => expense_types.type" placeholder="Select Type"></v-select>
      	</div>
      </div>
      <div class="col-sm-4">
				<div class="form-group float-left">
      		<button class="btn btn-primary" @click="getExpenses"><i class="fa fa-search"></i> Search</button>
      	</div>
			</div>
			<div class="col-sm-4">
				<div class="form-group float-left">
      		<button class="btn btn-danger" @click="reset"><i class="fa fa-times"></i> Reset</button>
      	</div>
			</div>
			<img v-if="expenses==''" src=""/>
			<datatable style="margin-top:1%;" :columns="columns" v-else>
				<tbody>
					<tr v-for="expense in expenses" :key="expense.id">
						<td>{{expense.type}}</td>
						<td>{{expense.description}}</td>
						<td>{{expense.amount}}</td>
						<td>{{expense.date}}</td>
						<td>{{expense.created_date}}</td>
						<td>
							<button class="btn btn-primary" @click="viewExpense(expense)"><i class="fa fa-eye"></i></button>
							<button class="btn btn-danger" @click="deleteExpense(expense.id)"><i class="fa fa-trash"></i></button>
						</td>
					</tr>
				</tbody>
			</datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getExpenses(pagination.prevPageUrl)"
        @next="getExpenses(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->
<div class="modal" tabindex="-1" role="dialog" id="addModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Add Expense</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<div class="form-group">
							<label>Choose Type:*</label>
							<v-select v-model="type" type="text" label="type" :options="expense_types" :reduce="expense_types => expense_types.type" placeholder="Select Type"></v-select>
						</div>
						<div class="form-group">
							<label>Description:</label>
							<input type="text" v-model="description" placeholder="Enter expense description" class="form-control">
						</div>
						<div class="form-group">
							<label>Amount w/o Taxes:*</label>
							<input type="number" v-model="amount" placeholder="Enter the amount" class="form-control" min="1">
						</div>
						<div class="form-group">
							<label>Taxes:*</label>
							<input type="number" v-model="taxes" placeholder="Enter the taxes" class="form-control" min="1">
						</div>
						<div class="form-group">
							<label>Total Amount:*</label>
							<input type="number" v-model="total_amount" placeholder="Enter the total amount" class="form-control" min="1">
						</div>
						<div class="form-group">
							<label>Date:*</label>
							<input type="date" v-model="date" placeholder="Enter the date" class="form-control">
						</div>
						<div class="form-group">
							<label>Bill Category:*</label>
							<v-select v-model="bill_category" type="text" label="type" :options="bill_categories" :reduce="bill_categories => bill_categories.type" placeholder="Select Bill Category"></v-select>
						</div>
						<div class="form-group">
							<label>Bill Type:*</label>
							<v-select v-model="bill_type" type="text" label="type" :options="bill_types" :reduce="bill_types => bill_types.type" placeholder="Select Bill Type"></v-select>
						</div>
						<div class="form-group">
							<label>Invoice No.:</label>
							<input type="text" v-model="invoice_no" placeholder="Enter expense invoice no." class="form-control">
						</div>
						<div class="form-group">
							<label>GST No.:</label>
							<input type="text" v-model="gst_no" placeholder="Enter GST no." class="form-control">
						</div>
						<div class="form-group">
							<label>TDS No.:</label>
							<input type="text" v-model="tds_no" placeholder="Enter TDS no." class="form-control">
						</div>
						<div class="form-group">
							<label>TAN No.:</label>
							<input type="text" v-model="tan_no" placeholder="Enter TAN no." class="form-control">
						</div>
						<div class="form-group">
							<label>PAN No.:</label>
							<input type="text" v-model="pan_no" placeholder="Enter PAN no." class="form-control">
						</div>
						<div class="form-group">
							<label>Remarks:</label>
							<input type="text" v-model="remarks" placeholder="Enter remarks" class="form-control">
						</div>
						<div class="form-group">
							<button class="btn btn-primary" @click="update">Update</button>
						</div>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

<div class="modal" tabindex="-1" role="dialog" id="viewModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">View Expense</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						{{curr}}
							
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 import Datatable from '../../datatable.vue';
     import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {datatable:Datatable, pagination:Pagination},
        
        created(){
        	this.getExpenses();
        	this.getExpenseTypes();
        	this.getBillTypes();
        	this.getBillCategories();
        },
        
        data(){
        	let columns = [
        		{width:'10%', label:'Type', name:'type'},
      			{width:'20%', label:'Descripiton', name:'description'},
      			{width:'20%', label:'Amount', name:'amount'},
      			{width:'10%', label:'Date', name:'date'},
      			{width:'20%', label:'Entered On', name:'created_date'},
      			{width:'10%', label:'Manage', name:'manage'},
        	];
        	
        	return {
        		columns: columns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		expenses: [],
         		type: '',
         		date: '',
         		amount: '',
         		description: '',
         		taxes: '',
         		total_amount: '',
         		bill_category: '',
         		bill_type: '',
         		invoice_no: '',
         		gst_no: '',
         		tds_no: '',
         		tan_no: '',
         		pan_no: '',
         		remarks: '',
         		bill_categories: [],
         		bill_types: [],
         		expense_types: [],
         		curr: [],
         		from: '',
         		to: '',
         		search_type: ''
        	}
        },
        
        methods : {
        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},
    			
    			getExpenses(){
    				axios.post("/api/getExpenses", {from: this.from, to: this.to, type: this.search_type})
    				.then(response => {
    					this.expenses = response.data.data.data;
    					this.configPagination(response.data.data);
    				})
    			},
    			
    			getExpenseTypes(){
    				axios.post("/api/getAllExpenseTypes")
    				.then(response => {
    					this.expense_types = response.data;
    				})
    			},
    			
    			getBillTypes(){
        		axios.post("/api/getAllBillTypes")
        		.then(response => {
        			this.bill_types = response.data;
        		})
        	},
        	
        	getBillCategories(){
        		axios.post("/api/getAllBillCategories")
        		.then(response => {
        			this.bill_categories = response.data;
        		})
        	},
        	
        	viewExpense(expense){
        		this.curr = expense;
        		$("#viewModal").modal("show");
        	},
    			
    			addModal(){
    				this.type= '';
         		this.date= '';
         		this.amount= '';
         		this.description= '';
         		this.taxes= '';
         		this.total_amount= '';
         		this.bill_category= '';
         		this.bill_type= '';
         		this.invoice_no= '';
         		this.gst_no= '';
         		this.tds_no= '';
         		this.tan_no= '';
         		this.pan_no= '';
         		this.remarks = '';
    				$("#addModal").modal("show");
    			},
    			
    			update(){
    				axios.post("/api/addExpense", {
    					type: this.type,
         			date: this.date,
         			amount: this.amount,
         			description: this.description,
         			taxes: this.taxes,
         			total_amount: this.total_amount,
         			bill_category: this.bill_category,
         			bill_type: this.bill_type,
         			invoice_no: this.invoice_no,
         			gst_no: this.gst_no,
         			tds_no: this.tds_no,
         			tan_no: this.tan_no,
         			pan_no: this.pan_no,
         			remarks: this.remarks
    				})
    				.then(response => {
    					if(response.data == 200){
    						toast.fire({
    							icon: 'success',
    							title: 'Expense Added'
    						});
    						this.getExpenses();
    					}
    					else
    						toast.fire({
    							icon: 'error',
    							title: 'Failed'
    						});
    				})
    				.catch(() => {
    					toast.fire({
    						icon: 'error',
    						title: 'Failed'
    					});
    				})
    			},
    			
    			deleteExpense(id){
    				axios.post("/api/deleteExpense", {id: id})
    				.then(response => {
    					if(response.data == 200){
    						toast.fire({
    							icon: 'success',
    							title: 'Expense Deleted'
    						});
    						this.getExpenses();
    					}
    					else
    						toast.fire({
    							icon: 'error',
    							title: 'Failed'
    						});
    				})
    				.catch(() => {
    					toast.fire({
    						icon: 'error',
    						title: 'Failed'
    					});
    				})
    			},
    			
    			reset(){
    				this.from = '';
    				this.to = '';
    				this.type = '';
    				this.getExpenses();
    			}
        }
    }
</script>
